import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { updateHeaderConfig } from '@reducers/details';
import { SingleBatchOrBatchList } from '@v2/pages/common/components/SingleBatchOrBatchList/SingleBatchOrBatchList';

interface BatchDetailsBatchProps {}

const BatchDetailsBatchComponent: FC<BatchDetailsBatchProps> = ({
  productionBatchStatistics,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  const { batchId } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
        <SingleBatchOrBatchList displaySingleItem batchId={batchId} />
    </DetailsPageWrapper>
  );
};

const BatchDetailsBatch = connect(null, {
  getNCFileById,
  productionBatchStatistics,
  getTools,
  clearTools,
  updateHeaderConfig,
})(BatchDetailsBatchComponent);

export { BatchDetailsBatch };
